exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".company-wrap[data-v-c5af6c8a],.rating-wrap[data-v-c5af6c8a]{padding:40px 0}.rating-wrap[data-v-c5af6c8a]{text-align:center;display:flex;align-items:center;flex-direction:column}.btn-wrap[data-v-c5af6c8a]{text-align:center;margin-top:20px}.fade-enter-active[data-v-c5af6c8a]{transition:all .2s ease}.fade-leave-active[data-v-c5af6c8a]{transition:all .4s cubic-bezier(1,.5,.8,1)}.fade-enter[data-v-c5af6c8a],.fade-leave-to[data-v-c5af6c8a]{transform:translateX(10px);opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c5af6c8a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/components/organisms/OrganismRatingForm.vue
// module id = 1272
// module chunks = 0